<template>
    <modal :visible.sync="visible" width="500px" :title="title">
        <div class="uk-padding-small">
            <el-form label-width="100px">
                <el-form-item :label="$t('integration.customer')" v-if="getIsSys()">
                    {{ model.sceneName }}
                </el-form-item>
                <el-form-item :label="$t('integration.name')">
                    {{ model.alarmTriggerName }}
                </el-form-item>
                <el-form-item :label="$t('integration.monitoring_point')">
                    {{ model.carrierName }}
                </el-form-item>

                <el-form-item :label="$t('integration.event')">
                    <i v-if="triggerEvent[model.event]" :class="triggerEvent[model.event].icon"
                        :title="$t(triggerEvent[model.event].title)" class="cursor-pointer"></i>
                </el-form-item>

                <el-form-item :label="$t('integration.operator')">
                    {{ model.operator }}
                </el-form-item>

                <el-form-item :label="$t('integration.operation_time')">
                    {{ $timetransition(model.createTime) }}
                </el-form-item>

                <el-form-item :label="$t('integration.record_time')">
                    {{ $timetransition(model.updateTime) }}
                </el-form-item>

                <el-form-item :label="$t('integration.explain')">
                    <!-- 需要判断权限 无编辑权限使用文本展示 数据源为异常原因  -->
                    <el-select v-model="model.reasonId" v-if="hasEditPermission" style="width: 200px;">
                        <el-option :label="reason.title" :value="reason.id" :key="reason.id"
                            v-for="reason in reasonList"></el-option>
                    </el-select>

                    <div v-else>
                        {{ reason }}
                    </div>
                </el-form-item>

                <el-form-item :label="$t('integration.describe')">
                    <!-- 需要判断权限 无编辑权限使用文本展示  -->
                    <el-input v-model="model.desc" v-if="hasEditPermission" type="textarea" style="width: 80%;"></el-input>
                    <div v-else>{{ model.desc }}</div>
                </el-form-item>
            </el-form>
        </div>

        <template #footer>
            <el-button type="primary" @click="save" v-if="hasEditPermission">{{ $t('integration.preservation') }}</el-button>
            <el-button @click="visible = false">{{ $t('integration.cancel') }}</el-button>
        </template>
    </modal>
</template>

<script>
import { getLogDetail, updateAlarmLog } from '@/api/modules/alarmLog';
import { triggerEvent } from '@/utils/convert';
import { exReasons } from '@/api/modules/abnormal';
import { hasPermission, getIsSys } from '@/utils/permission';

export default {
    props: ['show', 'title', 'id'],
    watch: {
        id(newVal) {
            getLogDetail(newVal).then(res => {
                this.model = res.result;
            });
        },
        'model.sceneId': {
            handler(newval) {
                this.getExReason(newval);
            }
        }
    },
    data() {
        return {
            model: {},
            reasonList: []
        };
    },
    computed: {
        getIsSys: () => getIsSys,
        visible: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
        triggerEvent: () => triggerEvent,
        hasEditPermission() {
            return hasPermission(['editAlarmSwitchLog']);
        },
        reason() {
            const item = this.reasonList.find(item => item.id === this.model.reasonId);
            if (item) {
                return item.title;
            } else return undefined;
        }
    },
    methods: {
        save() {
            const { id, reasonId, desc } = this.model;
            updateAlarmLog({ id, reasonId, desc }).then(res => {
                this.$message.success($t('integration.saved_successfully'));
                this.$emit('getList');
            });
            this.visible = false;
        },
        // 获取异常原因
        getExReason(scopeId) {
            exReasons({ scope: scopeId }).then(res => {
                this.reasonList = res.result;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-select-dropdown__item {
    max-width: 200px;
}
</style>
